const BG_REF_KEY = 'bg_ref';

const appendParamsToUrl = (param, url, root = false) => {
    if (!url) url = window.location.href;
    const urlData = new URL(url, window.location.origin);
    const params = { ...getQueryParams(), ...param };
    const query = Object.entries(params)
        .filter(([key, value]) => !!value)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    const { pathname, host, search, origin } = urlData;
    return root ? [`${origin}${pathname}`, query.trim()].filter(Boolean).join('?') : [`${pathname}`, query.trim()].filter(Boolean).join('?');
}

const appendTrackIdToUrl = (url, root = true, openUtm = false) => {
    try {
        if (!url) return url;
        const trackId = sessionStorage.getItem(BG_REF_KEY);
        const { utm_source, utm_medium, utm_campaign } = getQueryParams();

        const urlData = new URL(url, window.location.origin);
        if (trackId && !urlData.searchParams.has(BG_REF_KEY)) {
            urlData.searchParams.set(BG_REF_KEY, trackId);
        }

        if (openUtm && utm_source && !urlData.searchParams.has('utm_source')) {
            urlData.searchParams.set('utm_source', utm_source);
            if (utm_medium) urlData.searchParams.set('utm_medium', utm_medium || 'referral');
            if (utm_campaign) urlData.searchParams.set('utm_campaign', utm_campaign);
        }
        const { pathname, search } = urlData;
        return root ? urlData.toString() : `${pathname.trim()}${search.trim()}`;
    } catch (e) {
        return url;
    }
}

const navigationRepack = (url, root = false) => {
    if (!url) return url;
    return appendTrackIdToUrl(url, root, true);
}

document.addEventListener('click', function(event) {
    const link = event.target.closest('a[href]');
    if (link && link.href) {
        const originalHref = link.href;
        const newHref = appendTrackIdToUrl(originalHref);

        if (newHref !== originalHref) {
            event.preventDefault();
            if (link.target === '_blank') {
                window.open(newHref);
            } else window.location.href = newHref;
        }
    }
});

const getQueryParams = (name, url) => {
    const queryString = url ? (url.split('?')[1] || '') : window.location.search;
    const params = new URLSearchParams(queryString);
    // name为空返回整个对象备用
    if (name == null) {
        const result = {};
        params.entries().forEach(item => {
            const [ key, value ] = item;
            // 优先使用 decodeURIComponent 解码
            result[decodeURIComponent(key)] = decodeURIComponent(value);
        })
        return result;
    }
    const value = params.get(name);
    return value ? decodeURIComponent(value) : null;
}

/**
 * 初始化tm code
 * @param code
 */
const initTrackModule = (code = BG_REF_KEY) => {
    const originCode = getQueryParams(code);
    const localCode = sessionStorage.getItem(code);
    if (originCode && originCode !== localCode) {
        sessionStorage.setItem(code, originCode);
    } else {
        // sessionStorage.removeItem(code);
    }
}
initTrackModule();

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('a[href]').forEach(link => {
        const originalHref = link.href;
        const newHref = appendTrackIdToUrl(originalHref, true, true);
        if (newHref !== originalHref) {
            link.href = newHref;
        }
    });
});